export type NoticeItem = {
  id: string;
  title: string;
  description?: string;
  createdAt?: string;
  isUnread?: boolean;
};

/** Matches dashboard `studentNotices` items — field names may vary by API version. */
export function isStudentNoticeUnread(n: any): boolean {
  if (!n || typeof n !== "object") return true;
  if (n.readStatus === "read" || n.studentReadStatus === "read") return false;
  if (n.isRead === true) return false;
  return true;
}

